var modules_173205eb = {"container":"Radio_module_container__adb360ab","checked":"Radio_module_checked__adb360ab","control":"Radio_module_control__adb360ab","disabled":"Radio_module_disabled__adb360ab","read-only":"Radio_module_readOnly__adb360ab","input":"Radio_module_input__adb360ab","label":"Radio_module_label__adb360ab","icon":"Radio_module_icon__adb360ab"};
import "../../../assets/esm/components/Radio/src/Radio~Au1WOg-P.css";

export { modules_173205eb as default };
//# sourceMappingURL=Radio.module.less.js.map
